import { coreApi } from '@modules/core/api';
import { IS_SPAIN_ENV } from '@modules/core/utils';
import { useQuery } from '@tanstack/react-query';

const useGetCredits = (brokerageExternalId?: string, isEnabled = false) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['credits', brokerageExternalId],
    queryFn: () => coreApi.getCredits(brokerageExternalId || ''),
    enabled: !!brokerageExternalId && isEnabled && !IS_SPAIN_ENV,
    staleTime: 0,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetCredits;
